import { services } from '../../../../constants/services';
import { removeWithQueryParams } from '../../../../utils/api';

export class DeleteGeneralReservationLimitService {
	async run(params: any): Promise<void> {
		await removeWithQueryParams(`${services.generalReservationLimit}/deleteGeneralReservationLimit`, params);
	}
}
